import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiErrorDetail } from "../lib/api";
import { Loader2, Lock } from "lucide-react";
import Logo from "../components/Logo";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import AgencyMark from "../components/AgencyMark";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Login berhasil");
      navigate("/admin");
    } catch (e2) {
      setError(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0B2B5E] flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-30" aria-hidden />
      <div className="absolute -top-40 -right-40 h-80 w-80 rounded-full bg-[#FACC15]/20 blur-3xl" aria-hidden />
      <div className="absolute -bottom-40 -left-40 h-80 w-80 rounded-full bg-white/5 blur-3xl" aria-hidden />

      <div className="relative w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 text-white justify-center">
          <div className="h-12 w-12 rounded-md bg-white/10 border border-white/20 flex items-center justify-center overflow-hidden p-2">
            <Logo className="h-full w-full" />
          </div>

          <div className="text-left">
            <div className="text-[10px] tracking-[0.24em] uppercase text-[#FACC15]">
              Portal Petugas
            </div>
            <div className="font-display font-extrabold text-lg">Ditresnarkoba Jateng</div>
          </div>
        </div>

        <div className="rounded-xl bg-white p-8 shadow-2xl">
          <h1 className="font-display font-black text-2xl tracking-tight text-[#0F172A]">
            Masuk Dashboard
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Gunakan kredensial resmi untuk mengakses sistem.
          </p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label>Email Petugas</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="admin-email-input"
                className="h-11 mt-1.5"
                placeholder="admin@ditnarkoba-jateng.polri.go.id"
              />
            </div>
            <div>
              <Label>Password</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="admin-password-input"
                className="h-11 mt-1.5"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div data-testid="admin-login-error" className="text-sm rounded-md bg-red-50 text-red-700 border border-red-200 px-3 py-2">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-[#0B2B5E] text-white px-5 py-3 text-sm font-semibold hover:bg-[#081f47] transition-colors disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
              {loading ? "Memproses..." : "Masuk"}
            </button>
          </form>

          <div className="mt-6 pt-4 border-t border-slate-200 text-xs text-slate-500 text-center">
            Portal ini hanya untuk petugas resmi. Semua aktivitas dipantau.
          </div>
        </div>

        <div className="text-center text-xs text-slate-400 mt-6">
          © {new Date().getFullYear()} Polda Jawa Tengah
        </div>
      </div>
    </div>
  );
}
